import React from 'react';
import styled from 'styled-components';

interface AvailableTimeItemProps {
  readonly label: string;
  readonly name: string;
  readonly value: string;
  readonly selected: boolean;
  readonly onChange: () => void;
}

export const AvailableTimeItem: React.FC<AvailableTimeItemProps> = ({
  label,
  name,
  value,
  selected,
  onChange,
}) => {
  const id = `${name}-${value}`;

  return (
    <Wrapper>
      <Radio
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={selected}
        onChange={onChange}
      />
      <Label
        htmlFor={id}
        style={{
          background: selected ? '#000' : '#fff',
          color: selected ? '#fff' : '#000',
        }}
      >
        {label}
      </Label>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: inline-block;
`;

const Radio = styled.input`
  display: none;
`;

const Label = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  padding: 16px 20px;
  height: 48px;
  font-size: 14px;
  border: 0.5px solid #ccc;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
`;
